<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="open">
      <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="closeCreateFolderModal">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>
  
          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div class="flex justify-center">
                <div class="mt-3 text-center sm:mt-0 sm:text-left w-4/5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900 text-center">
                    Create a folder
                  </DialogTitle>
                  <div class="mt-2">
                    <form @submit.prevent="createFolder" class="flex flex-col justify-center items-center">
                        <input type="text" name="{{$name}}" id="name"
                            v-model="name"
                            class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm">
                        <SaveButton type="submit" text="Create" class="mt-4 w-1/2" />    
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </template>
  
<script>
    import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
    import SaveButton from '../../components/form/SaveButton.vue'
    import { mapStores } from 'pinia';
    import { useDocumentsStore } from '../../stores/documentsStore';

    export default {
        components: {
            Dialog,
            DialogOverlay,
            DialogTitle,
            TransitionChild,
            TransitionRoot,
            SaveButton
        },
        props: {
            open: {
                type: Boolean,
                required: true,
                default: true
            },
            attachableType: {
                type: String,
                required: true
            },
            attachableId: {
                type: Number,
                required: true
            }
        },
        computed: {
            ...mapStores(useDocumentsStore)
        },
        data() {
            return {
                name: ''
            }
        },
        methods: {
            closeCreateFolderModal() {
                this.$emit('close');
            },
            async createFolder(){
                try{
                    await this.documentsStore.createFolder(this.name)
                    this.closeCreateFolderModal()
                    this.name = ''
                }
                catch(e){
                    console.log(e);
                }
            }
        }
    }

</script>